export default "__VITE_ASSET__Bwj7tecz__"